export default __webpack_public_path__ + "static/media/crude-on2.9e3dd676.svg";